
import { Component, Prop, Vue } from "vue-property-decorator";
import InfoButton from "@/components/V2/QuickActions/InfoButton.vue";
import { track } from "@amplitude/analytics-browser";

const CLASS = "quick-action";

@Component({
  components: {
    InfoButton,
  },
})
export default class QuickAction extends Vue {
  @Prop({ type: String, default: null }) readonly label: string;
  @Prop({ type: String, default: null }) readonly icon: string;
  @Prop({ type: String, default: null }) readonly info: string;
  @Prop({ type: [Boolean, Number], default: false }) readonly disabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly selected: boolean;
  @Prop({ type: Function }) readonly method: any;
  @Prop({ type: String, default: "bottom" }) readonly tooltipPosition: string;

  get classes() {
    const { disabled, selected } = this;

    return {
      [`${CLASS}_default`]: !disabled,
      [`${CLASS}_disabled`]: disabled,
      [`${CLASS}_selected`]: selected,
    };
  }

  get hasInfo() {
    return this.info;
  }

  emitAction() {
    if (this.disabled) return;

    this.method?.();

    this.$emit("emit");

    track("Clicked Quick action button", { service: this.label });
  }
}
